var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.6295 97.2C89.6295 101.176 86.406 104.4 82.4295 104.4C78.453 104.4 75.2295 101.176 75.2295 97.2C75.2295 93.2235 78.453 90 82.4295 90C86.406 90 89.6295 93.2235 89.6295 97.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.8L20 5L20 33.8",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.0353,
    y1: 41.8995,
    x2: 93.7469,
    y2: 38.1619,
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.0926,
    y1: 58.9427,
    x2: 99.7424,
    y2: 55.9107,
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.818 92.7738L100.819 57",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderImage);
export default __webpack_public_path__ + "static/media/loader_image.e786961a7d946223c2e88d432c05d6bb.svg";
export { ForwardRef as ReactComponent };